module.exports = __webpack_public_path__ + "static/img/zhaopian2_jpg.16dac36.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zhaopian2_jpg.png
// module id = D+aF
// module chunks = 1